import React from 'react';
import ErrorHandler from '../ErrorHandler';
import { Navigate } from "react-router-dom";
import LobbyUserStatsPanel from './LobbyUserStatsPanel';
import LobbyFriendsPanel from './LobbyFriendsPanel';
import LobbyFeaturedContentPanel from './LobbyFeaturedContentPanel';
import { emit } from '../Socket/game.Emitters';
import JoinRoom from './Lobby.Join';
import { gameStateManager } from '../../App';
import toast from 'react-hot-toast';
import BannerAd from "../Ads/BannerAd";
import axios from 'axios';
import { restUrl } from '../../env';
import { WaitUntilLoggedIn } from '../Core/LoginManager'

export default class Lobby extends React.Component
{
  constructor( props )
  {
    super( props );
    this.joinRoomRef = React.createRef();
  }

  state = {
    error: '',
    numOnline: '?',
    numRooms: '?',
    numGamesToday: '?'
  };

  // Flag to prevent duplicate initialization in React Strict Mode
  isInitialized = false;

  async componentDidMount()
  {
    // Prevent duplicate initialization in React Strict Mode
    if( this.isInitialized )
    {
      return;
    }
    this.isInitialized = true;

    await WaitUntilLoggedIn( async () =>
    {
      await this.updateGlobalStats();
    } );
  }

  refreshRoomsList = async () =>
  {
    if( this.joinRoomRef.current )
    {
      await this.joinRoomRef.current.updateCurrentRoomsList();
    }
  }

  onJoinRoom( data )
  {
    const { roomId } = data;

    gameStateManager.joinExistingRoomSocket( roomId, () => { this.forceUpdate(); }, this.onServerErrorReceived );
  }

  onCreateNewRoom()
  {
    gameStateManager.createNewRoomSocket( () => { this.forceUpdate(); }, this.onServerErrorReceived );
  }

  onStartBotGame()
  {
    gameStateManager.createBotGame( () => { this.forceUpdate(); }, this.onServerErrorReceived );
  }

  onServerErrorReceived = errorData =>
  {
    // this.setState({ error: errorData });

    toast.error( errorData.content );
  }

  updateGlobalStats = async () =>
  {
    const response = await axios.post( `${restUrl}/global-stats`, {}, { withCredentials: true } );

    if( response.data.success )
    {
      this.setState(
        {
          numOnline: response.data.onlineUsers ?? 0,
          numRooms: response.data.numActiveRooms ?? 0,
          numGamesToday: response.data.numGamesToday ?? 0
        } );
    }
  }

  resetError = () =>
  {
    this.setState( { error: '' } );
    this.updateRoomsList();
  };


  render()
  {
    const {
      error,
      numOnline,
      numRooms,
      numGamesToday
    } = this.state;

    if( error )
    {
      emit.closeConnection();
      return <ErrorHandler redirectUrl="/" error={ error } resetError={ this.resetError } />;
    }


    if( gameStateManager.socketConnectedRoomId )
    {
      return (
        <Navigate to={ "/#" + gameStateManager.socketConnectedRoomId } replace={ true } />
      );
    }

    return (
      <>
        <div className="left-page-panel">

          <div className='lobby-create-room-button panel-button colour-brand-bg' onClick={ () =>
          {
            this.onCreateNewRoom();
          } }>
            CREATE ROOM
          </div>

          <div className='lobby-play-vs-bots-button panel-button colour-dark-accent-bg' onClick={ () =>
          {
            this.onStartBotGame();
          } }>
            PLAY VS BOTS
          </div>

          <div className='lobby-profile-summary-panel rounded-floating-element colour-dark-shade-bg'>
            <LobbyUserStatsPanel />
          </div>

          <div className='lobby-friends-panel rounded-floating-element colour-dark-shade-bg'>
            <LobbyFriendsPanel />
          </div>

        </div>

        <div className="middle-page-panel rounded-floating-element colour-dark-accent-bg">

          <JoinRoom
            ref={ this.joinRoomRef }
            onJoinRoom={ ( data ) =>
            {
              this.onJoinRoom( data );
            } } />

          <div className='lobby-online-stats-bar colour-dark-shade-bg'>
            <div className='lobby-online-stats-bar-stat'><span className='lobby-online-stats-bar-stat-value'>{ numOnline.toLocaleString() }</span> online</div>
            <div className='lobby-online-stats-bar-stat'><span className='lobby-online-stats-bar-stat-value'>{ numRooms.toLocaleString() }</span> rooms</div>
            <div className='lobby-online-stats-bar-stat'><span className='lobby-online-stats-bar-stat-value'>{ numGamesToday.toLocaleString() } </span> games today</div>
          </div>

        </div>

        <div className="right-page-panel">

          {/* <div className="lobby-right-panel-embedded-ad-slot">
            <BannerAd
              slot="5944871172"
              customStyle={ { display: "inline-block", width: "300px", height: "244px" } }
              refreshSec={ process.env.REACT_APP_LOBBY_EMBEDDED_AD_REFRESH_FREQUENCY ?? 60 }
            />
          </div> */}

          <div className="lobby-featured-content-panel rounded-floating-element colour-dark-shade-bg">
            <LobbyFeaturedContentPanel />
          </div>
        </div>
      </>
    );
  }
}
